import React from "react";
import styled, { css } from "styled-components";

import "leaflet/dist/leaflet.css"

import SideInfo from "./SideInfo/index.js";
import SideMenu from "./SideMenu/index";
import MapProvider from "./MapProvider.js";
import MapContext from "./MapContext.js";
import Preview from "./Preview.js";

class MyMap extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMenuOpen: false,
            currentlyOpenedPage: ""
        }
    }

    handleOpenMenu = (current) => {
        // If the current page is opened, when the button is clicked again we close the page
        if (current === this.state.currentlyOpenedPage) {
            this.setState(state => ({
                isMenuOpen: !state.isMenuOpen,
                currentlyOpenedPage: ""
            }))
        } else {
            this.setState(state => ({
                isMenuOpen: true,
                currentlyOpenedPage: current
            }))
        }
    }

    render() {
        console.log("hello");
        return <MapProvider>
            <MapContext.Consumer>
                { ({ refs, mode, handleMode, resetAllSelection, isSideInfoOpen, currentCountry, currentIso, contributions, preview }) => {
                    return <Main mode={ mode }>
                        <div style={{ position: "relative", width: "calc(100% - 64px)" }} >
                            <Map ref={ refs.map } />
                            <MapOverlayer>
                                <SideInfo 
                                    handleClose={ resetAllSelection }
                                    isDisplayed={ isSideInfoOpen }
                                    country={ currentCountry } 
                                    currentIso={ currentIso }
                                    displayLeft={ true }
                                    contributions={ new Intl.NumberFormat('en').format(contributions) }
                                    mode={ mode } />
                                <Preview
                                    mode={ mode }
                                    preview={ preview }
                                    currentCountry={ currentCountry } />
                            </MapOverlayer>
                        </div>
                        <SideMenu 
                            mode={ mode }
                            handleMode={ handleMode }
                            currentlyOpenedPage={ this.state.currentlyOpenedPage }
                            handleOpenMenu={ this.handleOpenMenu }
                            isMenuOpen={ this.state.isMenuOpen } />
                    </Main> 
                } }
            </MapContext.Consumer>
        </MapProvider>
    }
}

const Main = styled.main`
    width: 100%;
    min-height: 100vh;
    display: flex;

    ${ props => props.mode === "light"
        ? css`color: black;`
        : css`color: white;`}
`

const MapOverlayer = styled.div`
`

const Map = styled.div`
    width: 100%;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
`

export default MyMap;